<template>
    <div id="videoBox" :style="'width:'+config.width+';height:'+config.height">
        <div class="videoLayer">
            <div class="top">
                <i class="el-icon-error" @click="closeVideo"></i>
            </div>
            <video id="video" width="100%" height="100%" :poster="config.poster">
                <source :src="config.url" type="video/mp4">
            </video>
            <div class="bottom" v-show="videoReady">
                <div class="progress"></div>
                <div class="progressBox">
                    <el-row>
                        <el-col class="but" :span="1">
                            <img :src="status? './static/images/icon-play.png':'./static/images/icon-pause.png'" alt="" @click="playPause">
                        </el-col>
                        <el-col :span="21">
                            <div class="line">
                                <p class="onLine" :style="'width:'+playWidth+'%'"></p>
                                <p class="offLine"></p>
                            </div>
                        </el-col>
                        <el-col style="text-align:center" :span="2">
                            <span class="time">{{hasPlayed}}/{{allPlayed}}</span>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"Video",
    props:{
        config:{
            type: Object,
            required: true
        }
    },
    data(){
        return{
            videoReady: false,//视频是否已加载完毕
            status: true,//开始、暂停
            playWidth: 0, //进度条
            hasPlayed: "00:00",//已播放
            allPlayed: "02:30" //总时长
        }
    },
    mounted:function(){
        let _self = this;
        let allTime = 1;
        let tag = document.getElementById("video");
        tag.oncanplaythrough = function(){
            // console.log("可以播放视频");
            _self.videoReady = true;
            allTime = parseInt(this.duration);
            let min = Math.floor(allTime/60) >= 10? Math.floor(allTime/60):'0'+Math.floor(allTime/60);
            let second = Math.floor(allTime%60) >= 10? Math.floor(allTime%60):'0'+Math.floor(allTime%60);
            _self.allPlayed = min + ":" + second;
        }
        tag.ontimeupdate = function(){
            let currTime = this.currentTime;
            let min = Math.floor(currTime/60) >= 10? Math.floor(currTime/60):'0'+Math.floor(currTime/60);
            let second = Math.floor(currTime%60) >= 10? Math.floor(currTime%60):'0'+Math.floor(currTime%60);
            _self.hasPlayed = min + ":" + second;
            _self.playWidth = (currTime/allTime)*100;
        }
        tag.onended = function(){
            _self.status = true;
        }
    },
    methods:{
        /**
         * 关闭视频
         */
        closeVideo:function(){
            let tag = document.getElementById("video");
            tag.load();
            this.status = true;
            this.$emit("closeVideo");
        },
        /**
         * 开始、暂停视频
         */
        playPause:function(){
            let tag = document.getElementById("video");
            if(this.status){
                tag.play();
            }else{
                tag.pause();
            }
            this.status = !this.status;
        }
    }
}
</script>
<style scoped>
    #videoBox{
        /* border: 1px solid red; */
        background: transparent;
        margin: 0 auto;
        min-width: 1000px;
        border-radius: 10px;
        overflow: hidden;
    }
    .videoLayer{
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        /* border: 1px solid green; */
    }
    .videoLayer .top{
        position: absolute;
        z-index: 10;
        width: 100%;
        height: 60px;
        /* border:1px solid red; */
    }
    .videoLayer .top i{
        font-size: x-large;
        float: right;
        margin: 16px 20px;
        cursor: pointer;
    }
    .videoLayer .bottom{
        position: absolute;
        bottom: 0;
        z-index: 10;
        width: 100%;
        height: 60px;
        /* border:1px solid red; */
    }
    .videoLayer .bottom .progress{
        position: absolute;
        background: #000;
        opacity: 0.6;
        width: 98%;
        height: 50px;
        margin: 0 10px;
        border-radius: 6px;
    }
    .videoLayer .bottom .progressBox{
        position: absolute;
        z-index: 10;
        width: 98%;
        height: 50px;
        color: #fff;
        margin: 0 10px;
        /* border: 1px solid green; */
    }
    .videoLayer .bottom .progressBox .but{
        width:40px;
        text-align: center;
    }
    .videoLayer .bottom .progressBox .but img{
        margin-top: 15px;
    }
    .videoLayer .bottom .progressBox .line{
        position: relative;
        width:100%;
        height: 50px;
    }
    .videoLayer .bottom .progressBox .line p{
        position: absolute;
        top: 23px;
    }
    .videoLayer .bottom .progressBox .line p.offLine{
        width: 100%;
        border-top: 1px solid #999;
    }
    .videoLayer .bottom .progressBox .line p.onLine{
        z-index: 30;
        border-top: 1px solid #fff;
    }
    .videoLayer .bottom .progressBox .time{
        font-size: 12px;
        line-height: 45px;
    }
</style>





// WEBPACK FOOTER //
// src/components/Video.vue